import {
  TOGGLE_ITEMS_DISCLAIMER_CHECKED,
  RECEIVE_INITIAL_PAGE_LOAD_PARAMS,
  UPDATE_STEP_1_COMPLETE_STATUS,
  UPDATE_STEP_2_COMPLETE_STATUS,
  UPDATE_ALL_STEPS_COMPLETE_STATUS,
  UPDATE_LOCALE,
  UPDATE_EXCHANGES_ENABLED,
  UPDATE_GIFT_FLAG,
  UPDATE_GIFT_EMAIL,
  STORE_OVERRIDE_CODE,
  STORE_BROWSER_FINGERPRINT,
  NAVIGATION_TO_LANDING_PAGE,
  UPDATE_IS_SIMPLE_RETURNS,
  UPDATE_SECURE_MODE,
  RECEIVE_PENDING_CANCEL_RETURN_ID,
  RECEIVE_DISPLAY_HELP_FLAG,
  RECEIVE_PICKUPS_MODAL_VERSION,
  RECEIVE_PICKUPS_ENABLE_CTA,
  RECEIVE_ACCESS_TOKEN,
  NAVIGATION_TO_STEP_1,
  RECEIVE_CURRENCY_FORMAT,
  SET_LOADING,
  SET_DEFER_OVERRIDE,
  SET_SHOW_ADDRESS_ON_STEP_3,
  CAPTURE_USER_EMAIL,
} from '../../actions/page';
import defaultCurrencyFormat from '../../constants/currencyFormats/angular-locale_en-us.json';
import { getProductTypeFromURL } from '../../lib/productHelpers';
import { sessionId } from '../../lib/fingerprint';
import { MODAL_VERSION_3 } from '../../constants/pickups';
import { BYPASS_STEP } from '../../actions/returnOptions';
import { urlParam } from '../../lib/url';
import { isDeferredOverride } from '../../lib/storeAssociate';

export const initialState = {
  locale: '',
  itemsDisclaimerChecked: false,
  step1Complete: false,
  step2Complete: false,
  allStepsComplete: false,
  languageCode: '',
  countryCode: '',
  productType: getProductTypeFromURL(window.location.href),
  exchangesEnabled: false,
  giftOrder: false,
  giftEmail: '',
  overrideCode: '',
  mode: urlParam({ param: 'mode' }),
  deferOverride: isDeferredOverride({ mode: urlParam({ param: 'mode' }) }),
  browserFingerprint: '',
  sessionId: sessionId(),
  isSimpleReturns: false,
  initialPageLoadParams: {},
  secureMode: false,
  pendingCancelReturnId: null,
  displayHelp: false,
  pickupsModalVersion: MODAL_VERSION_3,
  pickupsEnableCTA: false,
  accessToken: '',
  bypassSteps: [],
  currencyFormat: defaultCurrencyFormat,
  loading: false,
  showAddressOnStep3: false,
  captureUserEmail: false,
};

export default (
  state = initialState,
  {
    type,
    data: {
      step1Complete,
      step2Complete,
      allStepsComplete,
      locale,
      languageCode,
      countryCode,
      exchangesEnabled,
      overrideCode,
      giftOrder,
      giftEmail,
      browserFingerprint,
      isSimpleReturns,
      params,
      secureMode,
      pendingCancelReturnId,
      displayHelp,
      pickupsModalVersion,
      pickupsEnableCTA,
      accessToken,
      bypassSteps,
      currencyFormat,
      loading,
      deferOverride,
      showAddressOnStep3,
      captureUserEmail,
    } = {},
  } = {},
) => {
  switch (type) {
    case TOGGLE_ITEMS_DISCLAIMER_CHECKED:
      return {
        ...state,
        itemsDisclaimerChecked: !state.itemsDisclaimerChecked,
      };

    case RECEIVE_INITIAL_PAGE_LOAD_PARAMS:
      return {
        ...state,
        initialPageLoadParams: params,
      };

    case UPDATE_STEP_1_COMPLETE_STATUS:
      return {
        ...state,
        step1Complete,
      };

    case UPDATE_STEP_2_COMPLETE_STATUS:
      return {
        ...state,
        step2Complete,
      };

    case UPDATE_ALL_STEPS_COMPLETE_STATUS:
      return {
        ...state,
        allStepsComplete,
      };

    case UPDATE_LOCALE:
      return {
        ...state,
        locale,
        languageCode,
        countryCode,
      };

    case UPDATE_GIFT_FLAG:
      return {
        ...state,
        giftOrder,
      };

    case UPDATE_GIFT_EMAIL:
      return {
        ...state,
        giftEmail,
      };

    case STORE_OVERRIDE_CODE:
      return {
        ...state,
        overrideCode,
      };

    case UPDATE_EXCHANGES_ENABLED:
      return {
        ...state,
        exchangesEnabled,
      };

    case STORE_BROWSER_FINGERPRINT:
      return {
        ...state,
        browserFingerprint,
      };

    case NAVIGATION_TO_LANDING_PAGE:
      return {
        ...state,
        step1Complete: false,
        step2Complete: false,
        allStepsComplete: false,
        bypassSteps: [],
      };

    case NAVIGATION_TO_STEP_1:
      return {
        ...state,
        bypassSteps: [],
      };

    case UPDATE_IS_SIMPLE_RETURNS:
      return {
        ...state,
        isSimpleReturns,
      };

    case UPDATE_SECURE_MODE:
      return {
        ...state,
        secureMode,
      };

    case RECEIVE_PENDING_CANCEL_RETURN_ID:
      return {
        ...state,
        pendingCancelReturnId,
      };

    case RECEIVE_DISPLAY_HELP_FLAG:
      return {
        ...state,
        displayHelp,
      };

    case RECEIVE_PICKUPS_MODAL_VERSION:
      return {
        ...state,
        pickupsModalVersion,
      };

    case RECEIVE_PICKUPS_ENABLE_CTA:
      return {
        ...state,
        pickupsEnableCTA,
      };

    case RECEIVE_ACCESS_TOKEN:
      return {
        ...state,
        accessToken,
      };

    case BYPASS_STEP:
      return {
        ...state,
        bypassSteps,
      };

    case RECEIVE_CURRENCY_FORMAT: {
      return {
        ...state,
        currencyFormat,
      };
    }

    case SET_LOADING:
      return {
        ...state,
        loading,
      };

    case SET_DEFER_OVERRIDE:
      return {
        ...state,
        deferOverride,
      };

    case SET_SHOW_ADDRESS_ON_STEP_3:
      return {
        ...state,
        showAddressOnStep3,
      };

    case CAPTURE_USER_EMAIL:
      return {
        ...state,
        captureUserEmail,
      };

    default:
      return state;
  }
};
